import React from 'react';

const SvgSettings = (props) => (
  <svg width={'100%'} viewBox="0 0 40 40" {...props}>
    <defs>
      <style>
        {`.settings_svg__a{fill:none;stroke:${props.color ||
          '#acacac'};stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}`}
      </style>
    </defs>
    <g transform="translate(364 104)">
      <path
        className="settings_svg__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        d="M-332-82.952v-2.1a1 1 0 00-.836-.986l-2-.333a9.368 9.368 0 00-1.009-2.439l1.179-1.65a1 1 0 00-.107-1.289l-1.481-1.481a1 1 0 00-1.289-.107l-1.65 1.179a9.369 9.369 0 00-2.439-1.009l-.333-2a1 1 0 00-.986-.836h-2.1a1 1 0 00-.986.836l-.333 2a9.369 9.369 0 00-2.439 1.009l-1.65-1.179a1 1 0 00-1.289.107l-1.481 1.481a1 1 0 00-.107 1.289l1.179 1.65a9.368 9.368 0 00-1.009 2.439l-2 .333a1 1 0 00-.836.986v2.1a1 1 0 00.836.986l2 .333a9.368 9.368 0 001.009 2.439l-1.179 1.65a1 1 0 00.107 1.289l1.481 1.481a1 1 0 001.289.107l1.65-1.179a9.369 9.369 0 002.439 1.009l.333 2a1 1 0 00.986.836h2.1a1 1 0 00.986-.836l.333-2a9.369 9.369 0 002.439-1.009l1.65 1.179a1 1 0 001.289-.107l1.481-1.481a1 1 0 00.107-1.289l-1.179-1.65a9.368 9.368 0 001.009-2.439l2-.333a1 1 0 00.836-.986z"
      />
      <circle
        className="settings_svg__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        cx={5}
        cy={5}
        r={5}
        transform="translate(-349 -89)"
      />
      <path fill="none" d="M-364-104h40v40h-40z" />
    </g>
  </svg>
);

export default SvgSettings;
